import React from "react";

import GridItem from "../../views/Grid/GridItem.js";
import GridContainer from "../../views/Grid/GridContainer.js";
import Table from "../../views/Table/Table.js";
import Card from "../../views/Card/Card.js";
import CardHeader from "../../views/Card/CardHeader.js";
import moment from "moment";
import CardBody from "../../views/Card/CardBody.js";

import style from "./styles.module.css";
import Snackbar from "../utils/snackbar/Snackbar";
import { withRouter } from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";
import { connect } from "react-redux";
import { useEffect, useState } from "react";
import { getData } from "../../restfulservices/httpHandler.js";
import { Pagination } from "@material-ui/lab";

const Ticket = (props) => {
  const [filteredData, setFilteredData] = React.useState(null);
  const [ticketcount, setticketCount] = useState(null);
  const [alert, setAlert] = React.useState(false);
  const [page, setPage] = React.useState(1);
  const [openFilter, setOpenFilter] = useState(false);
  const [dateType, setDateType] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [ticketType, setTicketType] = useState("");
  const [isFilterOn, setIsFilterOn] = useState(false);
  const [filterQuery, setFilterQuery] = useState("");


  let limit = 20;

  useEffect(() => {
    fetchCategory();
  }, [page]);

  const fetchCategory = async () => {
  try {
    const url = isFilterOn
      ? `v1/ticket/getAllBuyTicket?page=${page}&limit=${limit}${filterQuery}`
      : `v1/ticket/getAllBuyTicket?page=${page}&limit=${limit}`;

    const res = await getData(url);

    setFilteredData(res?.data?.data?.history || []);
    setticketCount(res?.data?.data?.count || 0);
  } catch (err) {
    console.log(err);
    setFilteredData([]);
    setticketCount(0);
  }
};

  const applyFilter = async () => {
    try {
      let start = startDate;
      let end = endDate;

      if (dateType === "weekly") {
        start = moment().subtract(7, 'days').format("YYYY-MM-DD");
        end = moment().format("YYYY-MM-DD");
      }
      if (dateType === "monthly") {
        start = moment().subtract(30, 'days').format("YYYY-MM-DD");
        end = moment().format("YYYY-MM-DD");
      }
      if (dateType === "yearly") {
        start = moment().subtract(365, 'days').format("YYYY-MM-DD");
        end = moment().format("YYYY-MM-DD");
      }

      const query = `&startDate=${start}&endDate=${end}&ticketType=${ticketType}`;
      setFilterQuery(query);
      setIsFilterOn(true);

      const res = await getData(
        `v1/ticket/getAllBuyTicket?page=1&limit=${limit}${query}`
      );

      setFilteredData(res?.data?.data?.history ?? []);
      setticketCount(res?.data?.data?.count ?? 0);
      setPage(1);
      setOpenFilter(false);
    } catch (err) {
      console.log("Filter Error", err);
    }
  };


  const formatDate = (date) => {
    const res = moment(date).format("MMM Do YY");
    return res;
  };
  const isLoading = filteredData === null;
  const showData = !isLoading;
  const details = [];

  const handleChangePage = (event, value) => {
    setPage(value);
  };

  if (!isLoading && Array.isArray(filteredData)) {
    filteredData.forEach((val, index) => {
      details.push([
        index + 1,
        val?.userId?.name,
        val?.price,
        val?.userId?.role,
        val?.basicTicketNo,
        val?.royalTicketNo,
        val?.vipTicketNo,
        formatDate(val?.createdAt),
      ]);
    });
  }

  return (
    <GridContainer>
      <Snackbar open={alert} handleClose={() => setAlert(false)} />

      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="primary">
            <div className={style.cardHeader}>
              <h4>Ticket History</h4>
              <button className={style.filterBtn} onClick={() => setOpenFilter(true)}>
                Filter
              </button>
            </div>
          </CardHeader>
          <CardBody>
            {isLoading && (
              <div className={style.loader}>
                <CircularProgress />
              </div>
            )}

            {openFilter && (
              <div className={style.filterOverlay}>
                <div className={style.filterBox}>
                  <h3>Filter Tickets</h3>

                  {/* Date Range Type */}
                  <label>Date Range</label>
                  <select
                    value={dateType}
                    onChange={(e) => setDateType(e.target.value)}
                    className={style.selectInput}
                  >
                    <option value="">Select</option>
                    <option value="weekly">Weekly</option>
                    <option value="monthly">Monthly</option>
                    <option value="yearly">Yearly</option>
                    <option value="custom">Custom</option>
                  </select>

                  {/* Custom Date Fields */}
                  {dateType === "custom" && (
                    <>
                      <label>Start Date</label>
                      <input
                        type="date"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                        className={style.input}
                      />

                      <label>End Date</label>
                      <input
                        type="date"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                        className={style.input}
                      />
                    </>
                  )}

                  {/* Ticket Type */}
                  <label>Ticket Type</label>
                  <select
                    value={ticketType}
                    onChange={(e) => setTicketType(e.target.value)}
                    className={style.selectInput}
                  >
                    <option value="">All</option>
                    <option value="Royal">Royal</option>
                    <option value="VIP">VIP</option>
                    <option value="Basic">Basic</option>
                  </select>

                  <div className={style.filterActions}>
                    <button className={style.cancelBtn} onClick={() => setOpenFilter(false)}>Cancel</button>
                    <button className={style.applyBtn} onClick={applyFilter}>Apply</button>
                  </div>
                </div>
              </div>
            )}

            {!isLoading && filteredData?.length === 0 && (
              <div style={{ textAlign: "center", padding: "30px" }}>
                <h4>No Data Found</h4>
              </div>
            )}
            {showData && filteredData?.length > 0 && (
              <Table
                tableHeaderColor="primary"
                tableHead={[
                  "S.N",
                  "Name",
                  "Price",
                  "Role",
                  "Basic Ticket",
                  "Royal Ticket",
                  "Vip Ticket",
                  "Buy At",
                ]}
                tableData={details}
              />
            )}
          </CardBody>
        </Card>
      </GridItem>
      <div
        style={{ width: "100vw", display: "flex", justifyContent: "center" }}
      >
        <Pagination
          count={Math.ceil(parseInt(ticketcount) / limit)}
          page={page}
          onChange={handleChangePage}
        />
      </div>
    </GridContainer>
  );
};

const mapStateToProps = (state) => ({
  user: state.appReducer.user,
});
export default withRouter(connect(mapStateToProps)(Ticket));
